import Vue from "vue";
import store from '../store';
import VueRouter from "vue-router";

// LAYOUT
import header from '@/components/layouts/nav';
import sidebar from '@/components/layouts/sidebar';
import footer from '@/components/layouts/footer';

//MENU
import LoginCustomer from "../views/auth/Login.vue"

//MENU ADMIN
import Dashboard from "../views/admins/dashboard/Dashboard.vue"
import Admin from "../views/admins/admin/Admin.vue"
import Distributor from "../views/admins/distributor/Distributor.vue"
import Agent from "../views/admins/agent/Agent.vue"
import SlotDistributor from "../views/admins/slot-distributor/Distributor.vue"
import SlotAgent from "../views/admins/slot-agent/Agent.vue"
import Music from "../views/admins/music/Music.vue"
import Theme from "../views/admins/theme/Theme.vue"
import Events from "../views/admins/event/Event.vue"
import AllEvents from "../views/admins/all-event/Event.vue"
import Partner from "../views/admins/partner/Partner.vue"
import Challenge from "../views/admins/challenge/Challenge.vue"
import Website from "../views/admins/website/Website.vue"
import Bonus from "../views/admins/bonus/Bonus.vue"


//MENU Distributor
import DashboardDistributors from "../views/distributors/dashboard/Dashboard.vue"
import AgentDistributor from "../views/distributors/agent/Agent.vue"
import SlotAgentDistributor from "../views/distributors/slot-agent/Agent.vue"

//MENU Agents
import DashboardAgents from "../views/agents/dashboard/Dashboard.vue"
import MusicAgents from "../views/agents/music/Music.vue"
import LeaderBoard from "../views/agents/leaderboard/Leaderboard.vue"
import WebsiteAgent from "../views/agents/website/Website.vue"

//MENU For All Level
import Profile from "../views/profile/Profile.vue"
import Historys from "../views/history/Historys.vue"
import NotFound from "../views/error/404.vue"
import AddEvents from "../views/appearance/addEvent.vue"
import WaitingList from "../views/waitinglist/Waitinglist.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: '/login',
  },
  {
    path: "/login",
    name: "login",
    components: {content:LoginCustomer},
  },
  // ADMIN MENU
  {
    path: "/dashboard",
    name: "dashboard",
    components: {header:header, sidebar:sidebar, content:Dashboard, footer:footer},
    meta: {
      requiresAuth: true,
      level:1,
      title: 'Dashboard'
    }
  },
  {
    path: "/admin",
    name: "admin",
    components: {header:header, sidebar:sidebar, content:Admin, footer:footer},
    meta: {
      requiresAuth: true,
      level:1,
      title: 'Admins'
    }
  },
  {
    path: "/distributor",
    name: "distributor",
    components: {header:header, sidebar:sidebar, content:Distributor, footer:footer},
    meta: {
      requiresAuth: true,
      level:1,
      title: 'Distributors'
    }
  },
  {
    path: "/agent",
    name: "agent",
    components: {header:header, sidebar:sidebar, content:Agent, footer:footer},
    meta: {
      requiresAuth: true,
      level:1,
      title: 'Agents'
    }
  },
  {
    path: "/slot-distributor",
    name: "slot-distributor",
    components: {header:header, sidebar:sidebar, content:SlotDistributor, footer:footer},
    meta: {
      requiresAuth: true,
      level:1,
      title: 'Slot Distributors'
    }
  },
  {
    path: "/slot-agent",
    name: "slot-agent",
    components: {header:header, sidebar:sidebar, content:SlotAgent, footer:footer},
    meta: {
      requiresAuth: true,
      level:1,
      title: 'Slot Agents'
    }
  },
  {
    path: "/music",
    name: "music",
    components: {header:header, sidebar:sidebar, content:Music, footer:footer},
    meta: {
      requiresAuth: true,
      level:1,
      title: 'Music'
    }
  },
  {
    path: "/theme",
    name: "theme",
    components: {header:header, sidebar:sidebar, content:Theme, footer:footer},
    meta: {
      requiresAuth: true,
      level:1,
      title: 'Themes'
    }
  },
  {
    path: "/challenge",
    name: "challenge",
    components: {header:header, sidebar:sidebar, content:Challenge, footer:footer},
    meta: {
      requiresAuth: true,
      level:1,
      title: 'Challenge'
    }
  },
  {
    path: "/website",
    name: "website",
    components: {header:header, sidebar:sidebar, content:Website, footer:footer},
    meta: {
      requiresAuth: true,
      level:1,
      title: 'Website'
    }
  },
  {
    path: "/bonus",
    name: "bonus",
    components: {header:header, sidebar:sidebar, content:Bonus, footer:footer},
    meta: {
      requiresAuth: true,
      level:1,
      title: 'Bonus Agent'
    }
  },
  {
    path: "/event",
    name: "event",
    components: {header:header, sidebar:sidebar, content:Events, footer:footer},
    meta: {
      requiresAuth: true,
      level:1,
      title: 'Events'
    }
  },
  {
    path: "/partner",
    name: "partner",
    components: {header:header, sidebar:sidebar, content:Partner, footer:footer},
    meta: {
      requiresAuth: true,
      level:1,
      title: 'Partner'
    }
  },
  {
    path: "/detail-website/:id",
    name: "admin-detail-website",
    components: {header:header, sidebar:sidebar, content:WebsiteAgent, footer:footer},
    meta: {
      requiresAuth: true,
      level:1,
      title: 'Website'
    }
  },
  {
    path: "/all-event",
    name: "all-event",
    components: {header:header, sidebar:sidebar, content:AllEvents, footer:footer},
    meta: {
      requiresAuth: true,
      level:1,
      title: 'All Events'
    }
  },

  //DISTRIBUTOR MENU
  {
    path: "/distributor/dashboard",
    name: "distributor-dashboard",
    components: {header:header, sidebar:sidebar, content:DashboardDistributors, footer:footer},
    meta: {
      requiresAuth: true,
      level:2,
      title: 'Dashboard'
    }
  },
  {
    path: "/distributor/agent",
    name: "distributor-agent",
    components: {header:header, sidebar:sidebar, content:AgentDistributor, footer:footer},
    meta: {
      requiresAuth: true,
      level:2,
      title: 'Agents'
    }
  },
  {
    path: "/distributor/slot-agent",
    name: "distributor-slot-agent",
    components: {header:header, sidebar:sidebar, content:SlotAgentDistributor, footer:footer},
    meta: {
      requiresAuth: true,
      level:2,
      title: 'Slot Agents'
    }
  },

  //AGENT MENU
  {
    path: "/agent/dashboard",
    name: "agent-dashboard",
    components: {header:header, sidebar:sidebar, content:DashboardAgents, footer:footer},
    meta: {
      requiresAuth: true,
      level:3,
      title: 'Dashboard'
    }
  },
  {
    path: "/agent/music",
    name: "agent-music",
    components: {header:header, sidebar:sidebar, content:MusicAgents, footer:footer},
    meta: {
      requiresAuth: true,
      level:3,
      title: 'Music'
    }
  },
  {
    path: "/agent/leaderboard",
    name: "agent-leaderboard",
    components: {header:header, sidebar:sidebar, content:LeaderBoard, footer:footer},
    meta: {
      requiresAuth: true,
      level:3,
      title: 'Leaderboard'
    }
  },
  {
    path: "/agent/detail-website/:id",
    name: "agent-website",
    components: {header:header, sidebar:sidebar, content:WebsiteAgent, footer:footer},
    meta: {
      requiresAuth: true,
      level:3,
      title: 'Website'
    }
  },
  {
    path: "/agent/partner",
    name: "agent-partner",
    components: {header:header, sidebar:sidebar, content:Partner, footer:footer},
    meta: {
      requiresAuth: true,
      level:3,
      title: 'Partner'
    }
  },
  {
    path: "/agent/event",
    name: "agent-event",
    components: {header:header, sidebar:sidebar, content:Events, footer:footer},
    meta: {
      requiresAuth: true,
      level:3,
      title: 'Events'
    }
  },

  //PUBLIC MENU
  {
    path: "/profile",
    name: "profile",
    components: {header:header, sidebar:sidebar, content:Profile, footer:footer},
    meta: {
      requiresAuth: true,
      level:null,
      title: 'Profile'
    }
  },
  {
    path: "/waitinglist",
    name: "waitinglist",
    components: {header:header, sidebar:sidebar, content:WaitingList, footer:footer},
    meta: {
      requiresAuth: true,
      level:null,
      title: 'Waiting List Event'
    }
  },
  {
    path: "/historys",
    name: "historys",
    components: {header:header, sidebar:sidebar, content:Historys, footer:footer},
    meta: {
      requiresAuth: true,
      level:null,
      title: 'Historys'
    }
  },
  {
    path: "/details-event/:id/:slug",
    name: "details-event",
    components: {header:header, sidebar:sidebar, content:AddEvents, footer:footer},
    meta: {
      requiresAuth: true,
      level:null,
      title: 'Create Event'
    }
  },
  {
    path: '*',
    name: '404',
    components: {header:header, sidebar:sidebar, content:NotFound, footer:footer},
    meta: {
      requiresAuth: true,
      level:null,
      title: 'Not Found'
    }
  },
  {
    path: '/notfound',
    name: 'notfound',
    components: {header:header, sidebar:sidebar, content:NotFound, footer:footer},
    meta: {
      requiresAuth: true,
      level:null,
      title: 'Not Found'
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {

    if (store.getters['AuthControl/isLoggedIn']) {

      if(to.meta.level){
        if(to.meta.level == store.getters['AuthControl/authLevel']){
          next()
          return
        }
        next('/404')
        return
      }
      next()
      return
    }
    next('/login')

  } else {
    if (store.getters['AuthControl/isLoggedIn'] && store.getters['AuthControl/authLevel'] == 1) {
      next('/dashboard')
      return
    }else if (store.getters['AuthControl/isLoggedIn'] && store.getters['AuthControl/authLevel'] == 2) {
      next('/distributor/dashboard')
      return
    }else if (store.getters['AuthControl/isLoggedIn'] && store.getters['AuthControl/authLevel'] == 2) {
      next('/agent/leaderboard')
      return
    }
    next()
  }
})

export default router;

